import PublicPackageApi from '@/api/public';

export default {
  namespaced: true,

  state: {
    list: [],
    meta: {},
    loading: false,
    error: null,
    params: {
      deviceHash: null,
      orderBy: {
        value: 'timestamp',
        desc: true
      },
      limit: {
        count: 100,
        offset: 0
      },
      term: ''
    },
  },

  actions: {
    async getList(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        const { data, meta } = await PublicPackageApi.getList(ctx.getters.params)
        ctx.commit('setList', data);
        ctx.commit('setMeta', meta);
      } catch (error) {
        console.log('error', error);
        ctx.dispatch('errors/pushError', { id: 'transactions', error: error.message }, { root: true });
        ctx.commit('setError', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    changeParams(context, params) {
      if (params.orderBy) {
        if (context.state.params.orderBy.value === params.orderBy.value) {
          params.orderBy.desc = !context.state.params.orderBy.desc;
        } else {
          params.orderBy.desc = true;
        }
      }
      context.commit('changeParams', params);
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setList(state, data) {
      state.list = data;
    },

    changeParams(state, data) {
      Object.assign(state.params, data);
    }
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    list: state => (state.list ? state.list : []),
    params: state => state.params
  }
};
